<template lang="pug">
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 6H1.5V4H22.5V6ZM22.5 13H1.5V11H22.5V13ZM22.5 20H1.5V18H22.5V20Z" fill="#141414"/>
	</svg>
</template>

<style lang="stylus" scoped>

</style>

<script>
export default {
	methods:{
		emitClick(event){
			this.$emit('click', event)
		}
	}
}
</script>
